<div class="modalerror" id="mdModal" tabindex="-1" role="dialog">
	<!--  style="display: block;" -->
	<div role="document">
		<div class="{{ dataModal.modalColour }}" style="border: solid 2px; padding: 10px">
			<div class="p-dialog-header">
				<h4 class="modal-title" id="defaultModalLabel" [innerHTML]="dataModal.titolo"></h4>
			</div>
			<div class="p-dialog-content" [innerHTML]="dataModal.body"></div>
			<div class="modal-footer">
				<button hidden class="btn btn-link waves-effect"></button>
				<!-- <button *ngIf="!dataModal.twoBtn" type="button" mat-button mat-dialog-close class="btn btn-link waves-effect">CHIUDI</button>
                <button *ngIf="dataModal.twoBtn" type="button" mat-button mat-dialog-close class="btn btn-link waves-effect">ANNULLA</button>
                <button *ngIf="dataModal.twoBtn" type="button" mat-button [mat-dialog-close]="true" class="btn btn-link waves-effect">CONFERMA</button> -->
			</div>
		</div>
	</div>
</div>

<!-- <div style="position: fixed;left: 100px;top: 150px;z-index: 200 !important;">pippo</div> -->
